import { Dispatch, useState } from "react"
import { getAuditHistoryView } from "src/app/shared/services/ViewAuditService"

export interface IViewAuditHistory {
  auditHistory: any
  isGettingList: boolean
  setAuditHistory: Dispatch<any>
  getAuditHistory: (payload: Partial<any>) => Promise<void>
}

export const useViewAuditHistory = (): IViewAuditHistory => {
  const [auditHistory, setAuditHistory] = useState<any>({
    data: [],
    total: 0,
    pageIndex: 0,
    pageSize: 10,
    secCode: '',
    companyID: '',
    drcr: '',
    amount: 0,
  })
  const [isGettingList, setIsSettingList] = useState<boolean>(false)

  const getAuditHistory = async (payload: any) => {
    setIsSettingList(true);
    try {
      const res = await getAuditHistoryView(payload)
      if (res?.data) {
        setAuditHistory(res?.data)
      }
    } catch (err: any) {
      console.log('err', err)
    } finally {
      setIsSettingList(false)
    }
  }
  return {
    isGettingList,
    auditHistory,
    setAuditHistory,
    getAuditHistory
  }
}